<template>
  <div>
    <div v-if="loggedIn" class="wrapper">
      <nav v-if="false">
        <ul>
          <li><router-link :to="{ name: 'Pages' }">Stranice</router-link></li>
          <li><router-link :to="{ name: 'AdminFAQ' }">FAQ</router-link></li>
        </ul>
      </nav>
      <router-view />

    </div>

    <login v-else @login="isLoggedIn()" />
  </div>
</template>

<script>
import Login from '@/views/Login'

import 'element-ui/lib/theme-chalk/index.css'

export default {
  components: {
    Login
  },

  data () {
    return {
      loggedIn: null
    }
  },

  created () {
    this.isLoggedIn()
  },

  methods: {
    isLoggedIn () {
      const ls = localStorage.getItem('token')
      this.loggedIn = ls === '4af584ff5b785b6b94d81fd19e642187' || null
    }
  }
}
</script>

<style lang="scss" scoped>
  nav {
    width: 100%;
    height: 70px;
    line-height: 70px;
    text-align: center;
    background-color: #fff;
    ul {
      li {
        display: inline-block;
        margin: 0 25px;
        .router-link-exact-active {
          color: $link;
          font-weight: bold;
        }
      }
    }
  }
</style>
